import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface DangerZoneProps {
  title?: string;
  description?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function DangerZone({
  title = "Danger Zone",
  description,
  children,
  className,
}: DangerZoneProps) {
  return (
    <Card className={cn("border-destructive/40", className)}>
      <CardHeader>
        <CardTitle className="typo-heading text-destructive">{title}</CardTitle>
        {description && (
          <CardDescription className="typo-body text-[color:var(--color-text-md)]">
            {description}
          </CardDescription>
        )}
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
          {children}
        </div>
      </CardContent>
    </Card>
  );
}
